import React from "react";

function IconPushNotification({ fill = "" }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      className={fill} 
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.9693 2.51851C13.3258 2.50631 12.6684 2.5 12 2.5C10.5209 2.5 9.09517 2.5309 7.7562 2.58819C5.3157 2.6926 4.09545 2.74481 3.13007 3.71745C2.16469 4.69009 2.12282 5.87683 2.03909 8.2503C2.01346 8.97679 2 9.72921 2 10.5C2 11.2708 2.01346 12.0232 2.03909 12.7497C2.12282 15.1232 2.16469 16.3099 3.13007 17.2825C4.09545 18.2552 5.31569 18.3074 7.75619 18.4118C7.83715 18.4153 7.91842 18.4186 8 18.4219V20.7701C8 21.1732 8.32679 21.5 8.72991 21.5C8.90419 21.5 9.07273 21.4376 9.20503 21.3242L11.3845 19.4553C11.9325 18.9855 12.2064 18.7506 12.532 18.6266C12.8576 18.5026 13.2282 18.4955 13.9693 18.4815C14.7498 18.4667 15.5098 18.4432 16.2437 18.4118C18.6843 18.3074 19.9046 18.2552 20.8699 17.2826C21.8353 16.3099 21.8772 15.1232 21.9609 12.7497C21.9865 12.0232 22 11.2708 22 10.5C22 10.3324 21.9994 10.1657 21.9981 10"
        stroke={fill}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M22 5C22 6.38071 20.8807 7.5 19.5 7.5C18.1192 7.5 17 6.38071 17 5C17 3.61929 18.1192 2.5 19.5 2.5C20.8807 2.5 22 3.61929 22 5Z"
        stroke={fill}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.1257 10.5H12.0007M8.125 10.5H8M16.125 10.5H16M12.2507 10.5C12.2507 10.6381 12.1388 10.75 12.0007 10.75C11.8627 10.75 11.7507 10.6381 11.7507 10.5C11.7507 10.3619 11.8627 10.25 12.0007 10.25C12.1388 10.25 12.2507 10.3619 12.2507 10.5ZM8.25 10.5C8.25 10.6381 8.13807 10.75 8 10.75C7.86193 10.75 7.75 10.6381 7.75 10.5C7.75 10.3619 7.86193 10.25 8 10.25C8.13807 10.25 8.25 10.3619 8.25 10.5ZM16.25 10.5C16.25 10.6381 16.1381 10.75 16 10.75C15.8619 10.75 15.75 10.6381 15.75 10.5C15.75 10.3619 15.8619 10.25 16 10.25C16.1381 10.25 16.25 10.3619 16.25 10.5Z"
        stroke={fill}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export default IconPushNotification;
